import { useMemo } from 'react';
import { useIntl } from 'react-intl';

const ExerciseTypes = {
  Exercise: 'Exercise',
  FillInTheBlanksExercise: 'FillInTheBlanksExercise',
};

const exerciseTypes = [
  {
    labelKey: 'exercise.types.AbstractExercise',
    id: ExerciseTypes.Exercise,
  },
  {
    labelKey: 'exercise.types.FillInTheBlanksExercise',
    id: ExerciseTypes.FillInTheBlanksExercise,
  },
];

export default function useExerciseTypeSelector() {
  const intl = useIntl();

  const options = useMemo(() => {
    return exerciseTypes.map((t) => ({
      label: intl.formatMessage({ id: t.labelKey }),
      id: t.id,
    }));
  }, [intl]);

  return options;
}
